import React, { useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from "@fortawesome/free-solid-svg-icons";

//Components
import MainCard from '../../../components/MainCard/MainCard';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import ModalCustomized from '../../../components/Modal/Modal';
import TextField from '../../../components/TextField/TextField';
import Loading from '../../../components/Loading/Loading';

//Api
import tipoNotificacao_api from '../../../api/tipoNotificacao_api';

//Helpers
import { showMessage } from '../../../helpers/message';
import mascaras from '../../../helpers/mascaras';
import { validarCampos, objCampo } from '../../../helpers/ValidadorDeCampos';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';

//Estado inicial da notificação
function initialStateNotificacao() {
    return {
        descricao: "",
        prazoJustificativas: "",
        destinoNotificacao: "Gerador",
        status: "Ativo",
        fotosObrigatorias: "",
        justificativas: []
    }
}
export default function TipoNotificacoes({ permissao }) {
    //Estado que guarda os dados da notificação a ser Cadastrada/Editada
    const [notificacao, setNotificacao] = useState(initialStateNotificacao);

    //Estado que guarda as notificações que serão listadas
    const [tipoNotificacoes, setTipoNotificacoes] = useState([]);

    //Estado de controle do modal de Cadastro/Edição
    const [openModal, setOpenModal] = useState(false);

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Estado de controle dos erros nos campos obrigatorios
    const [errors, setErrors] = useState({});

    //Campos obrigatorios do Cadastro/Edição
    const campos = [
        objCampo({ name: "descricao", required: true }),
        objCampo({ name: "prazoJustificativas", required: true }),
        objCampo({ name: "justificativas", required: true }),
    ];

    //Faz a troca do estado do modal
    const toggleModal = () => {
        if (openModal) {
            setNotificacao(initialStateNotificacao);
            setErrors({});
        }
        setOpenModal(!openModal);
    };

    //Carrega a notificações que serão listadas
    const loadTipoNotificacoes = () => {
        setLoading(true);
        tipoNotificacao_api.GetList().then(response => {
            response.data = response.data.map(tipoNotificacao => {
                tipoNotificacao.justificativas = tipoNotificacao.justificativas.map(value => {
                    return { value: value.id, label: value.descricao, removerJustificativa: value.removerJustificativa }
                });
                return tipoNotificacao;
            });

            setTipoNotificacoes(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }

    //Carrega as notificações que serão listadas assim que o componente é iniciado
    useEffect(() => {
        loadTipoNotificacoes();
    }, []);

    //Change dos campos da notificação
    const onChangeNotificacao = (e) => {
        const { name, value } = e.target;
        const _notificacao = {
            ...notificacao,
            [name]: value
        };
        const campo = campos.filter(c => c.name == name);
        const erros = validarCampos(_notificacao, campo);
        if (erros[1].length == 0) {
            const _errors = { ...errors };
            delete _errors[name];
            setErrors(_errors);
        } else {
            setErrors({ ...errors, ...erros[0] });
        }
        setNotificacao(_notificacao);
    }

    //Adiciona/Edita uma notificação
    const addNovaNotificacao = () => {
        const erros = validarCampos(notificacao, campos);
        if (erros[1].length > 0) {
            setErrors(erros[0]);
            return;
        }
        if (notificacao.fotosObrigatorias > 3) {
            setErrors({ fotosObrigatorias: { message: "O valor máximo é de 3 fotos" } });
            return;
        }
        const _notificacao = { ...notificacao };
        if (_notificacao.justificativas) {
            _notificacao.justificativas = _notificacao.justificativas.map(v => {
                return { descricao: v.label, id: isNaN(v.value) ? 0 : v.value };
            })
        }
        setLoading(true);
        if (notificacao.id) {
            tipoNotificacao_api.Put(_notificacao).then(response => {
                showMessage("Sucesso", "Notificação editada com sucesso", "success");
                loadTipoNotificacoes();
                toggleModal();
                setNotificacao(initialStateNotificacao);
            }).catch(e => {
                showMessage("Aviso", e.message, "error", null);
            }).finally(f => setLoading(false));
        } else {
            tipoNotificacao_api.Post(_notificacao).then(response => {
                showMessage("Sucesso", "Notificação adicionada com sucesso", "success");
                loadTipoNotificacoes();
                toggleModal();
                setNotificacao(initialStateNotificacao);
            }).catch(e => {
                showMessage("Aviso", e.message, "error", null);
            }).finally(f => setLoading(false));
        }
    }

    //Armazena os dados para que seja feita a edição da notificação
    const editarNotificacao = (item) => {
        item.prazoJustificativas = item.prazoJustificativas.toString();
        setNotificacao(item);
        toggleModal();
    }
    const onChangeJustificativas = (inputValue) => {
        if (typeof inputValue === "object") {
            const [opcaoApagada] = notificacao.justificativas.filter(j => inputValue.filter(jn => jn.value == j.value).length == 0)
            if (!opcaoApagada.removerJustificativa) {
                showMessage("Aviso!", "Este item já foi utilizado e não pode ser excluído", "warning", null);
                return;
            }
        }
        setNotificacao({
            ...notificacao,
            justificativas: typeof inputValue === "object" ? [...inputValue] : [...notificacao.justificativas ? notificacao.justificativas : [], { value: inputValue, label: inputValue, removerJustificativa: true }]
        });
    }
    //Variavel que guarda as ações da tabela
    const actions = [];
    if (permissao == "Editar") {
        actions.push(actionsTable.editar(editarNotificacao));
    }
    //Cabeçalhos da tabela
    const headers = [
        { value: "Descrição", objectValue: "descricao", align: "left" },
        { value: "Destino da notificação", objectValue: "destinoNotificacao", align: "left" },
        { value: "Prazo da justificativa", objectValue: "prazoJustificativas", align: "right" },
        { value: "Status", objectValue: "status", align: "left" },
    ]

    return (
        <>
            {loading && <Loading />}
            <MainCard noCard btnCadastro={permissao === "Editar" ? "Adicionar" : null} onClickBtnCadastro={toggleModal}>
                <ModalCustomized title={notificacao.id ? <><FontAwesomeIcon icon={faEdit} /> Editar notificação</> : "Nova notificação"} isOpen={openModal} toggle={toggleModal} btnAction={notificacao.id ? <><FontAwesomeIcon icon={faEdit} className="me-3" /> Editar</> : "+ Adicionar"} btnActionColor={notificacao.id ? "warning text-light" : "success"} onClickBtnAction={addNovaNotificacao} btnClose>
                    <Row className='mb-4'>
                        <Col md="12" lg="12"><span className="text-danger fw-bold">*</span> Campos obrigatórios</Col>
                    </Row>
                    <Row>
                        <Col md={"12"} lg="12">
                            <TextField type={"textarea"} invalid={errors.descricao ? true : false} maxLength={"300"} label={"* Descrição"} name="descricao" value={notificacao.descricao} onChange={onChangeNotificacao} />
                            {errors.descricao && <span className={"form-control-label text-danger"}>{errors.descricao.message}</span>}
                        </Col>
                    </Row>
                    <Row>
                        <Col md={"12"} lg="6">
                            <TextField mask={mascaras.numeroMask} invalid={errors.prazoJustificativas ? true : false} label={"* Prazo de justificativa"} name="prazoJustificativas" value={notificacao.prazoJustificativas} onChange={onChangeNotificacao} />
                            {errors.prazoJustificativas && <span className={"form-control-label text-danger"}>{errors.prazoJustificativas.message}</span>}
                        </Col>
                        <Col md={"12"} lg="6">
                            <TextField mask={mascaras.numeroMask} invalid={errors.fotosObrigatorias ? true : false} label={"Fotos obrigatórias"} name="fotosObrigatorias" value={notificacao.fotosObrigatorias} onChange={onChangeNotificacao} />
                            {errors.fotosObrigatorias && <span className={"form-control-label text-danger"}>{errors.fotosObrigatorias.message}</span>}
                        </Col>
                        <Col md={"12"} lg="6">
                            <TextField label={"Destino da notificação"} name="destinoNotificacao" type={"select"} options={[{ text: "Gerador", value: "Gerador" }, { text: "Transportador", value: "Transportador" }, { text: "Destino", value: "Destino" }]} value={notificacao.destinoNotificacao} onChange={onChangeNotificacao} />
                        </Col>
                        <Col md={"12"} lg="6">
                            <TextField label={"Status"} name="status" type={"select"} options={[{ text: "Ativo", value: "Ativo" }, { text: "Inativo", value: "Inativo" }]} value={notificacao.status} onChange={onChangeNotificacao} />
                        </Col>
                        <Col md="12" lg="12" className='mt-2'>
                            <TextField invalid={!!errors.justificativas} label={"* Opções de justificativas"} type="select" creatable name={"justificativas"} onChange={onChangeJustificativas} value={notificacao.justificativas ? notificacao.justificativas : []} />
                        </Col>
                    </Row>
                </ModalCustomized>
                <div className="mt-4">
                    <TabelaListagem actions={actions} title={"Lista de notificações"} options={{ print: false, search: true, pagination: true }} headers={headers} items={tipoNotificacoes} />
                </div>
            </MainCard>
        </>
    )
}